import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "../../../../components/Common/Modal/Modal";
import { deleteGroupActionHandler } from "../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import classes from "./DeleteGroup.module.scss";
import { FormattedMessage } from "react-intl";

const DeleteGroup = ({
  deleteGroupModal,
  setDeleteGroupModal,
  selectedRowData,
  handleSearchQuery,
  setSelectedRowData,
}) => {
  const dispatch = useDispatch();
  const [deleteGroupResponse, setDeleteGroupResponse] = useState([]);
  const [deleteGroupLoader, setdeleteGroupLoader] = useState(false);

  const handleSubmit = () => {
    setdeleteGroupLoader(true);
    const deletePromises = selectedRowData?.map((data) => {
      return dispatch(deleteGroupActionHandler(data?.UserGroupId)).then((response) => {
        console.log("Response for UserGroupId:", data?.UserGroupId, response);
        if (response && response.status === 200) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `${data?.Name} user group successfully deleted.`
            )
          );
          setDeleteGroupResponse((prevState) => [...prevState, response?.data]);
        }
        return response;
      }).catch((error) => {
        console.error("Error for UserGroupId:", data?.UserGroupId, error);
        return error;
      });
    }); 
    
    Promise.all(deletePromises).then((responses) => {
      console.log("All responses:", responses);
      if (responses.every((response) => response && response.status === 200)) {
        handleSearchQuery();
      }
      setSelectedRowData([]);
      setdeleteGroupLoader(false);
    }).catch((error) => {
      console.error("Error in Promise.all:", error);
      setdeleteGroupLoader(false);
    });
  };

  useEffect(() => {
    if (selectedRowData?.length === 0) {
      setdeleteGroupLoader(true);
      setDeleteGroupModal(false);
    }
  }, [
    deleteGroupResponse,
    selectedRowData,
    setDeleteGroupModal,
    handleSearchQuery,
  ]);

  return (
    <Modal
      handleSubmit={handleSubmit}
      isOpen={deleteGroupModal}
      heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
      toggle={() => setDeleteGroupModal(!deleteGroupModal)}
      buttonLabel1={<FormattedMessage id="OK_TXT" />}
      buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
      width={"46.2"}
      height={"26.9"}
      loading={deleteGroupLoader}
    >
      <div className={classes.deleteGroupModal}>
        <div>
          <FormattedMessage id="USERGROUP_DELETEGRP__MSG" />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteGroup;
